<template>
  <div class="tag-list">
    <slot name="prepend"></slot>
    <slot></slot>
    <slot name="append"></slot>
  </div>
</template>

<script setup></script>

<style lang="scss" scoped>
.tag-list {
  min-height: 42px;
  display: flex;
  align-items: center;
  flex: 1 100%;
  flex-wrap: wrap;
  gap: 5px 10px;
}
</style>
